﻿var videos = (function () {
    var ytEle, ytClipId, ytPlayerIsReady;
    var ytplayerReady = function () {
        console.log("Fired window.onYouTubeIframeAPIReady");
        ytPlayer = new YT.Player(ytEle, {
            width: '100%',
            videoId: ytClipId,
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            },
            playerVars: {
                autoplay: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0
            }
        });
        ytPlayerIsReady = true;
    }
    function onPlayerReady(event) {
        console.log("Player ready", event);
    }
    function onPlayerStateChange(state) {
        console.log("Player state change", event);
    }
    window.onYouTubeIframeAPIReady = ytplayerReady;
    return {
        init: function () {
            // Swap in YT player for heros with videos, decorated with e.g. data-ytid="6399oktVPVA" -> https://www.youtube.com/embed/6399oktVPVA
            $('[data-ytid]').on('click', function (e) {
                ytEle = $(e.currentTarget);
                ytClipId = ytEle.attr("data-ytid");
                var w = ytEle[0].clientWidth, h = ytEle[0].clientHeight;
                if (h < 250) h = 250; // set a min height
                ytEle.css('width', w + "px").css('height', h + "px");
                ytEle.parent().removeClass("has-video");
                ytEle = ytEle[0];
                // Inject the YT player script and go through the performance of initialisation...
                if (!ytPlayerIsReady) {
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else {
                    ytplayerReady(); // reinstate player, if it's been closed before
                }
            });
        }
    };
})();
$(document).ready(function () {
    videos.init();
});